<template>
  <div class="graph card">
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
    <!--<meta http-equiv="refresh" content="3600"> refresh page every 60 min -->
	      
    <div>
      <router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
              	<button style="background-color:#fff;border:none;">
                <img src="../assets/AquaWiz_trans_minimum.png" width="110"></button>
                </router-link>
        <span><img style="width: 25px;" src="../assets/CRA.png"></span>
        <span v-if="serial!=devname" style="font-size:1.1em; color:red; "><strong>{{s_number}} {{devname}}</strong></span>
        <span v-else style="font-size:1.1em; color:red; "><strong>{{devname}}</strong></span>
      
      <span style="float:right;">
			<button type="reset" class="btn-primary" @click="fillData(1)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][0]}}</button>
      <button type="reset" class="btn-primary" @click="fillData(3)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][5]}}</button>
      <button type="reset" class="btn-primary" @click="fillData(7)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][1]}}</button>
      <button type="reset" class="btn-primary" @click="fillData(30)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][2]}}</button>
      <button type="reset" class="btn-primary" @click="fillData(365)" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][3]}}</button>					
			<button type="reset" class="btn-primary" @click="row2csv()" style="font-size: 12px;border-radius: 5px">{{msglist[$route.params.language][6]}}</button>
			
			</span> 
    </div>
    <line-graph v-if="win_width>win_height" :chart-data="datacollection" :options="choptions" style="position: relative; height:90vh; width:100%"></line-graph>
    <line-graph v-else :chart-data="datacollection" :options="choptions" style="position: relative; height:45vh; width:100%"></line-graph>
  
  </div>
</template>

<script>
//import Log from 'loglevel';
import has from 'lodash/has';
import map from 'lodash/map';
import LineGraph from './LineGraph.vue'

const mlist = {
	'en': [
		'Day',
		'Week',
		'Month',
		'Year',
    'My KH',
    '3 days',
    'Download'],
  'vi': [
    'Ngày',
		'Tuần',
		'Tháng',
		'Năm',
    'KH Của Bể',
    '3 Ngày',
    'Tải Xuống'],
  'ms': [
		'Day',
		'Week',
		'Month',
		'Year',
    'My KH',
    '3 days',
    'Download'],
	'tw': [
		'天',
		'週',
		'月',
		'年',
    '我的KH',
    '3天',
  '下載'],
	'cn': [
		'天',
		'週',
		'月',
		'年',
    '我的KH',
    '3天',
    '下载'],
}

let PURL = process.env.SERVER;


function getFieldValues(res, fieldName) {
  let fValues = [];
  //console.log('data field: ', fieldName);
  if (fieldName.match(/^field/)) {
    fValues = map(res, function (entry) {
      // console.log("entry: ", entry[1], entry.length);
      if (entry.length >= 2) {
        let obj = entry[1];
        return obj[fieldName];
      } else {
        return "undefined";
      }
    });
  }
  //console.log("data values: ", fValues);
  return fValues;
}

function getGraph(Vue, range, serial) {
  //console.log("KH-graph -- get data ", serial);
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let date = new Date().toJSON().slice(0,10);  //2023-03-06T08:44:50.444Z slice(0,10) ==>2023-03-06
  let stTime = new Date(date).getTime() - (range * 24 * 60 * 60 * 1000); //console.log("stTime: ", new Date().getDate(), new Date().toJSON());
  let stDate = new Date(stTime).toJSON();
  
  if (Vue.$route.params.sidx != null) {localStorage.setItem('sidx', Vue.$route.params.sidx);} // when reload webpage, sidx will be forget and = undefined, null
  let sidx=localStorage.getItem('sidx');  // restore sidx from localstorage after webpage reload
  if (range != null) {localStorage.setItem('range', range);} // when reload webpage, range will be forget and = undefined, null
  range=localStorage.getItem('range');  // restore range from localstorage after webpage reload
  serial = user.data.devices[sidx]; 
  Vue.s_number = serial.split('-')[2].substring(2);  // 00002.substring(2) = 002
  Vue.devname= user.devname[sidx];
  Vue.serial = serial; //to display on graph
  let url = PURL + '/api/v1/query/device/' + serial + '/graph';
  
  if (range > 0) {
    // url += '?stTime=' + stTime;
    url += '?date=' + stDate;
  }

  // asynch call
  if (serial) {
    let rftime=localStorage.getItem('rftime'); // get last webpage reload time
    let rfmin=Math.abs((new Date() - new Date(rftime)))/1000; // get time difference between page reload
    let res =localStorage.getItem('res'); // way to check res exist or not
    //console.log('rfmin',rfmin, 'rftime', rftime);
    
    if (rfmin > 600 || range >1 || rftime===null || res===null) {       // time difference bwtween reload > 60 sec, or request range more than 1 day, then load data from server
                                        //from my-kh to kh-graph page, if rftime=null, then rfmin = 1689581007 sec
      /////// get data from server //////  
      //console.log('Ca-graph -- get data from server');
      let p0 = Vue.$http.get(url);
        Promise.all([p0]).then(([r0]) => {
          //console.log("get graph data from server");
          Vue.message = 'graph returned';
          if (has(r0, "body.results.length") && r0.body.results.length !== 0) {
            res = r0.body.results; 
            if (range==1) {localStorage.setItem('res', JSON.stringify(res)); localStorage.setItem('rftime',new Date());}  // local save range=1 all data to reduce call API
            setGraphData(user, serial, res, Vue);
          }
        }, reason => {    // promise.all
          let rea=JSON.stringify(reason) ; 
          Vue.message = 'error: unknown error: ' + rea;
          if (rea.match(/no serial/gi)) {
            Vue.message = 'invalid serial numer';
          }
          console.log("reason: ", rea);
        });
      } else {  
        /////// get data from localstorage /////
        //console.log('Ca-graph -- get data from localstorage');
        res = JSON.parse(localStorage.getItem('res'));
        setGraphData(user, serial, res, Vue);
      }
      
  } else {    // if serial
      console.log('serial not found');
      Vue.message = 'serial not found';
  }    
  

  }

        
function setGraphData (user, serial,res, Vue) {                
        let times = [];
        // times = map(res, function(entry) { return entry[0]; });
        // tbd: change to minute later
        times = map(res, function(entry) { return new Date(entry[0]); });
        let fields = Object.keys(res[0][1]);
        let data = {
          labels: times,
          datasets: [],
        };
        console.log("KH-graph -- get data ", serial);  
          ////////// field 22 Tank KH difference display 0.11 ///////////
          let field22 = fields[0];
          //let label0 = 'Tank KH';
          var maxdata22 = 0;
          var mindata22 = 100;
          var total22 = 0;
          let dataEntry22 = {
            label: 'd-KH ',
            borderColor: '#6633ff',
            backgroundColor: '#6633ff',
            pointHoverBorderColor: 'black',
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'black',
            fill: false,
            yAxisID: 'y-axis-1',
            data: []
          };
          dataEntry22.data = getFieldValues(res, field22);
          for (let k = 0; k<dataEntry22.data.length; k++) {
            dataEntry22.data[k] = dataEntry22.data[k]/1000*-1;  // reverse delta KH for understanding
            Vue.tankKH = dataEntry22.data[k];  // to get last data
            maxdata22=Math.max(dataEntry22.data[k],maxdata22);
            mindata22=Math.min(dataEntry22.data[k],mindata22);
            total22+=dataEntry22.data[k];
          }
          let range22=Math.max((maxdata22-mindata22), 3.0-(maxdata22-mindata22));  // display range >=1.0 dKH
          let average22=total22/dataEntry22.data.length;
          data.datasets.push(dataEntry22);
          // console.log('maxdata=',maxdata22,', mindata=', mindata22);
           
      
            ////////// field 24 CaRx PH value display 6.5///////////
            let field24 = fields[2];
            //let label0 = 'Tank KH';
            var maxdata24 = 0;
            var mindata24 = 100;
            let dataEntry24 = {
              label: 'CaRx PH',
              borderColor: '#66cc66',
              backgroundColor: '#66cc66',
              pointHoverBorderColor: 'black',
              pointHoverRadius: 5,
              pointHoverBackgroundColor: 'black',
              fill: false,
              yAxisID: 'y-axis-2',
              data: []
            };
            dataEntry24.data = getFieldValues(res, field24);
            // divid by 1000 to show the real kH value, ex 7500 is actually 7.5
            for (let k = 0; k<dataEntry24.data.length; k++) {
              dataEntry24.data[k] = dataEntry24.data[k]/1000;
              maxdata24=Math.max(dataEntry24.data[k],maxdata24);
              mindata24=Math.min(dataEntry24.data[k],mindata24);
            }
            //console.log('data entry field24');
            //console.log('data entry field24: ', field24, dataEntry24.data);
            data.datasets.push(dataEntry24);
            //console.log('maxdata=',maxdata24, 'mindata=', mindata24);

           ////////// field 26 CO2 bubble execution count after fixed display 53///////////
          let field26 = fields[4];
          var maxdata26 = 0;
          var mindata26 = 100;
          let dataEntry26 = {
            label: 'CO2',
            borderColor: '#ffcc66',
            backgroundColor: '#ffcc66',
            pointHoverBorderColor: 'black',
            pointHoverRadius: 5,
            pointHoverBackgroundColor: 'black',
            fill: false,
            yAxisID: 'y-axis-2',
            data: []
          };
          dataEntry26.data = getFieldValues(res, field26);
          
          for (let k = 0; k<dataEntry26.data.length; k++) {
            dataEntry26.data[k] = dataEntry26.data[k];
            maxdata26=Math.max(dataEntry26.data[k],maxdata26);
            mindata26=Math.min(dataEntry26.data[k],mindata26);
          }
          //console.log('data entry field26');
          //console.log('data entry field26: ', field26, dataEntry26.data);
          data.datasets.push(dataEntry26);
           //console.log('maxdata=',maxdata26,', mindata=', mindata26);
         
         if (user.name === "default" || user.name === "khacra") {
              ////////// field 23 Error code 120 ///////////
              let field23 = fields[1];
              //let label0 = 'Tank KH';
              var maxdata23 = 0;
              var mindata23 = 100;
              let dataEntry23 = {
                label: 'Error',
                borderColor: '#80ceff',
                backgroundColor: '#80ceff',
                pointHoverBorderColor: 'black',
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'black',
                fill: false,
                yAxisID: 'y-axis-2',
                data: []
              };
              dataEntry23.data = getFieldValues(res, field23);
              for (let k = 0; k<dataEntry23.data.length; k++) {
              dataEntry23.data[k] = dataEntry23.data[k];
              maxdata23=Math.max(dataEntry23.data[k],maxdata23);
              mindata23=Math.min(dataEntry23.data[k],mindata23);
              }
              data.datasets.push(dataEntry23);
               
              ////////// field 25 Current CO2 bubble setting display 53 ///////////
              let field25 = fields[3];
              //let label0 = 'Tank KH';
              var maxdata25 = 0;
              var mindata25 = 100;
              let dataEntry25 = {
                label: 'Preset',
                borderColor: '#ff80b5',
                backgroundColor: '#ff80b5',
                pointHoverBorderColor: 'black',
                pointHoverRadius: 5,
                pointHoverBackgroundColor: 'black',
                fill: false,
                yAxisID: 'y-axis-2',
                data: []
              };
              dataEntry25.data = getFieldValues(res, field25);
              for (let k = 0; k<dataEntry25.data.length; k++) {
              dataEntry25.data[k] = dataEntry25.data[k];
              maxdata25=Math.max(dataEntry25.data[k],maxdata25);
              mindata25=Math.min(dataEntry25.data[k],mindata25);
              }
             data.datasets.push(dataEntry25);
             
            } // if user.name = super user
        
        //console.log("KH-graph -- complete data processing ", serial, new Date());
     

        let chartOpt = {
          title: {display : false,
            position : 'top',
            fontSize : 14,
            text: "KH Graph for Device " + serial
          },
          legend: {
                display: true,
                position: 'top'
             },  
          maintainAspectRatio: false,
          animation : false,
          bezierCurve : false,
          responsive: true,
          tooltips: {
             mode: 'index',
             intersect: false,
          },
          hover: {
             mode: 'nearest',
             intersect: false,
             axis: 'x'
          },
          scales: {
            xAxes: [{
              gridLines : {
                display : true
              },
              type: "time",
              time: {
                parser: 'MM/DD/YYYY HH:mm',
                //format: 'MM/DD HH:mm',
                tooltipFormat: 'll HH:mm',
                displayFormats: {          
                'minute': 'HH:mm',
                'hour': 'DD,HH:mm',
                'day': 'MM/DD',
                'week': 'MM/YY',
                'month': 'MM/YY',
                'quarter': 'MM/YY',
                'year': 'YYYY',
                }
              },
              ticks: {fontSize: 14,
                autoSkipPadding: 20,
                maxRotation: 0,},
              scaleLabel: {
                display: true,
                fontSize: 14,
                fontColor: 'black',
                //labelString: serial
              }
            },],
            yAxes: [{
              display: true, 
              position: 'left',
							id: 'y-axis-1',
              gridLines : {
                display : true
              },
              scaleLabel: {
                display: true,
                fontSize: 14
                //labelString: 'KH Value'
              },
              ticks: {fontSize : 14, 
                      //stepSize: 0.1,
                      beginAtZero:false, 
                      suggestedMin:Math.max(average22-range22/2,-5),
                      suggestedMax:Math.min(average22+range22/2,5)
              }
            },{
              display: true, 
              position: 'right',
							id: 'y-axis-2',
              gridLines : {
                display : true
              },
              scaleLabel: {
                display: true,
                fontSize: 14
                //labelString: 'Arb. unit'
              },
              ticks: {fontSize : 14, 
                      beginAtZero:false, 
                      //stepSize: 0.1,
                      suggestedMin: 0,
                      suggestedMax: 0.3  //maxdata26*3
                      //suggestedMin:Math.max(mindata26-(maxdata26-mindata26)/2,0),
                      //suggestedMax:Math.min(maxdata26*2+(maxdata26-mindata26)/2,14)
              }
            }]
          },
        };

        //console.log('dataset: ', data);
        // Vue.datacollection.labels = data.labels;
        // Vue.datacollection.datasets = data.datasets;
        Vue.datacollection = data;
        Vue.choptions = chartOpt;
        //console.log('datac: ', data, Vue.datacollection);
        //console.log('maxdata=',maxdata,', mindata=', mindata);

      } // if data length > 0


function ROWToCSV(Vue) {
    let data = Vue.datacollection;
    // Variable to store the final csv data
    //console.log("ROWToCSV: ", data, "data.labels:", data.labels);
    var csv_data = [];
    let csvrow = []; 
    let rowslength = data.datasets.length+1;  // +1 time labels
    
    for (var j = 0; j < data.labels.length; j++) { 
        csvrow = [];  // initialize array
        for (var i = 0; i < rowslength; i++) {    //[time, tank KH, PH signal] length = 3
        
          if (j===0) {  // first row is title label
            if (i===0){
              csvrow.push('time');  
            } else {
              csvrow.push(data.datasets[i-1].label);  // push label 
            } 
          } else { // j >0 then fill data
            if (i===0){  // 1st element is time data
                csvrow.push(data.labels[j]);  // row of time  
            } else {   // other element is data of tank KH, PH signal ....
                csvrow.push(data.datasets[i-1].data[j]);} 
          }  
        } // for i
        //console.log("csvrow= ", csvrow);
        csv_data.push(csvrow.join(",")); // Combine each column value with comma
    } // for j

    csv_data = csv_data.join('\n'); // Combine each row data with new line character
    //console.log("csv_data: ", csv_data);
    downloadCSVFile(Vue, csv_data);  // Call this function to download csv file 

  }
function downloadCSVFile(Vue, csv_data) {
            
    let CSVFile = new Blob([csv_data], {  // Create CSV file object and feed our csv_data into it
        type: "text/csv"
    });
    var temp_link = document.createElement('a'); // Create to temporary link to initiate download process
    let date = new Date().toISOString().
          replace(/T*/, '_').
          replace(/:/g, '').
          replace(/\..+/, '');
    temp_link.download = Vue.serial+date+".csv";
    console.log("output CSV file: ", temp_link.download);
    var url = window.URL.createObjectURL(CSVFile);
    temp_link.href = url;
    temp_link.style.display = "none";   // This link should not be displayed
    document.body.appendChild(temp_link);

    temp_link.click();// Automatically click the link to trigger download
    document.body.removeChild(temp_link);
  }

export default {
  components: {
    "line-graph": LineGraph
  },
  data() {
    return {
      title: "KH graph",
      serial:"",
      tankKH: "",
      message: "",
      msglist: mlist, 
      devname:"",
      s_number:"",
      datacollection: {},
      choptions: {},
      win_width:"",
      win_height:"",
      time_out:""
    }
  },
  
  created() {
    window.addEventListener("resize", this.resizeHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeHandler);
    clearInterval(this.time_out);
  },
  computed: {

  },

  methods: {
    fillData: function(range) {
      let user = JSON.parse(localStorage.getItem("user")) || this.$store.getters.user || {};   
     
      let serial = '';
      has(user, 'data.devices') ? serial = user.data.devices[this.$route.params.sidx] : "";
      this.datacollection = { labels: [], datasets: [] };
      getGraph(this, range, serial);
     
    },
    row2csv: function() {
      ROWToCSV(this);
    },
    resizeHandler() {
      this.win_width=window.innerWidth;
      this.win_height=window.innerHeight;
    },
    getRandomInt: () => {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    }
  },
  mounted() {
    //console.log('mounted: ', this, this.user1);
    let interv = 3600;  // set refresh data timer 1 hour = 3600 sec
	///if (this.$auth.loggedIn()) {   // keep graph page without logout
    this.time_out=setInterval(() => {     // set interval 3600 sec to re-plot KH graph 
    //console.log('mounted: set interval: ', interv );
    return this.fillData(1);
    }, interv*1000);
    return this.fillData(1); // show graph at 1st time
	///} else {
	///	this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
	///}
    //return this.fillData(1);
  }

}
</script>

<style>
.graph {
  max-width: 100%;
  width: 93%;
  min-width: 300px;
  margin: 3% 6% 3% 5%;
}
</style>



// WEBPACK FOOTER //
// CaRx_graph.vue?1e677b1e